import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public showComponent = true;
  constructor(private router: Router) {
    router.events.pipe(
      tap(() => {
        this.showComponent = !router.url.includes('/donate');
      })
    ).subscribe();
  }
}
